import React from "react";

export const NationalDistributionPartnerBadge = ({ show }: { show: boolean }) => {
  if (!show) return null;

  return (
    <div style={{ marginTop: 8 }}>
      <span
        style={{
          display: "inline-block",
          padding: "2px 10px",
          borderRadius: 12,
          backgroundColor: "#fff3cd",
          border: "1px solid #ffc107",
          color: "#7a5b00",
          fontSize: 12,
          fontWeight: 600,
        }}
      >
        National Distribution Partner
      </span>
      <div style={{ fontSize: 12, color: "#7a5b00", marginTop: 2 }}>
        Sales split 20/80
      </div>
    </div>
  );
};

export default NationalDistributionPartnerBadge;
